module.exports = __webpack_public_path__ + "img/a013_3.5ac47e40.jpg";